import React, { useState , useEffect} from "react";
import { Tab, Button , Icon, Segment, Header } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { PermissionForm, ListPermissions } from "../../../components/Admin/Permissions";
import { useAuth } from "../../../hooks";
import { Permission } from "../../../api";
import { hasPermission , isAdmin, isMaster} from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../../../pages/admin/Error";
import "./Permissions.scss";
import { useLanguage } from "../../../contexts";

const permissionController = new Permission();

export function Permissions() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const {
    user: { role },
    accessToken
  } = useAuth();

  const { translations } = useLanguage();
  
  const t = (key) => translations[key] || key ; // Función para obtener la traducción

  const [permissionsByRole, setPermissionsByRole]=useState([]);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(accessToken, role._id, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  const canCreate = isMaster(role) || isAdmin(role) || hasPermission(permissionsByRole, role._id, "permissions", "create");

  const panes = [
     {
      menuItem: t("by_permissions"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListPermissions isByRoles={false} permissionsActive={false} reload={reload} onReload={onReload} onOpenModal={canCreate ? onOpenCloseModal : null} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("by_roles"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListPermissions isByRoles={true} permissionsActive={true} reload={reload} onReload={onReload} onOpenModal={canCreate ? onOpenCloseModal : null} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
    { isMaster(role) || isAdmin(role) || hasPermission(permissionsByRole, role._id, "permissions", "view")?
    (<>
       <div className="permission-forms-page">
        <div className="permission-page-header-wrapper">
          <div className="permission-page-header">
            <span className="permission-page-title">{t("permissions")}</span>
          </div>
        </div>
      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={panes}
      />
    </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={t("create_permission")}
        size="small"
      >
        <PermissionForm close={onOpenCloseModal} onReload={onReload} />
      </BasicModal></>) : 
      <ErrorAccessDenied/>}
    </>
  )
}

